// ========================================
// src/hooks/usePermissions.js
// ========================================
import { useAuth } from '../context/AuthContext';
import { hasPermission, hasAnyPermission, hasAllPermissions, getUserPermissions } from '../utils/permissions';

export const usePermissions = () => {
  const { user } = useAuth();

  return {
    hasPermission: (permission) => hasPermission(user, permission),
    hasAnyPermission: (permissions) => hasAnyPermission(user, permissions),
    hasAllPermissions: (permissions) => hasAllPermissions(user, permissions),
    getUserPermissions: () => getUserPermissions(user),
    isAdmin: user?.role === 'administrateur',
    isManager: user?.role === 'gestionnaire',
    isOperator: user?.role === 'operateur',
    isReadOnly: user?.role === 'lecture',
  };
};
